"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationBar = void 0;
const React = require("react");
const colors_1 = require("../../../../types/colors");
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = require("../../atoms/Icon");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "NavigationBar");
const NavigationBar = ({ trailingActions, backPath, backLabel = "Back", backClick, noBackChevron = false, customBackComponent, className, children }) => {
    const Back = () => (React.createElement("div", { className: css("back") }, customBackComponent ? (customBackComponent) : (React.createElement(React.Fragment, null,
        !noBackChevron && (React.createElement(Icon_1.Icon, { variant: colors_1.TColorVariants.Secondary, name: "chevron-left" })),
        React.createElement("label", null, backLabel)))));
    return (React.createElement("div", { className: css("", { className }) },
        React.createElement("div", null,
            backPath && (React.createElement(react_router_dom_1.NavLink, { to: backPath },
                React.createElement(Back, null))),
            backClick && (React.createElement("a", { onClick: backClick },
                React.createElement(Back, null)))),
        React.createElement("h3", null, children),
        React.createElement("div", null, Array.isArray(trailingActions) &&
            trailingActions.map(action => (React.createElement(Icon_1.Icon, { key: action.icon, onClick: action.onClick, name: action.icon }))))));
};
exports.NavigationBar = NavigationBar;
//# sourceMappingURL=index.js.map